export default {"src":"/_next/static/media/ArrowRightWithTail.fff6ac8c.svg","height":8,"width":11,"blurWidth":0,"blurHeight":0};